import { mapState, mapGetters } from 'vuex'

export default {
	computed: {
		...mapState({
			campaign: s => s.campaign.campaign,
			campaignStatus: s => s.campaign.status,
			campaignFirstLoad: s => s.campaign.firstLoad
		}),
		...mapGetters({
			campaignNotLoaded: 'campaign/notLoaded',
			campaignPending: 'campaign/pending',
			campaignLoaded: 'campaign/loaded',
			campaignNotFound: 'campaign/notFound'
		})
	}
}
